import { Injectable } from '@angular/core';
//import { InAppBrowser,InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { Plugins } from '@capacitor/core';
const { Browser } = Plugins;


@Injectable({
  providedIn: 'root'
})
export class OpenlinkService {

  //===========================================================================================================================================
  //You have plenty of options for opening other browsers, such as using window.open(url), window.location = url or App's plugin openUrl method.
  //To make sure you can always open native Safari use window.location = url
  //===========================================================================================================================================

  /*optionsInAppBrowser : InAppBrowserOptions = {
    location : 'yes',//Or 'no' 
    hidden : 'no', //Or  'yes'
    clearcache : 'yes',
    clearsessioncache : 'yes',
    zoom : 'yes',//Android only ,shows browser zoom controls 
    hardwareback : 'yes',
    mediaPlaybackRequiresUserAction : 'no',
    shouldPauseOnSuspend : 'no', //Android only 
    closebuttoncaption : 'Close', //iOS only
    disallowoverscroll : 'no', //iOS only 
    toolbar : 'yes', //iOS only 
    enableViewportScale : 'no', //iOS only 
    allowInlineMediaPlayback : 'no',//iOS only 
    presentationstyle : 'pagesheet',//iOS only 
    fullscreen : 'yes',//Windows only    
  };*/

  constructor(    
    //private inAppBrowser: InAppBrowser,
  ) { }

  //Servono ad apripre un link nel browser di default
  /*public openWithSystemBrowser(url: string){//Apre una maschera esterna all'App
    let target = "_system";
    this.inAppBrowser.create(url,target,this.optionsInAppBrowser);
  }
  public openWithInAppBrowser(url: string){//Apre nell'App
    let target = "_blank";
    this.inAppBrowser.create(url,target,this.optionsInAppBrowser);
  }
  public openWithCordovaBrowser(url: string){//Apre nell'App
    let target = "_self";
    this.inAppBrowser.create(url,target,this.optionsInAppBrowser);
  }*/  

  async openBrowser(url: string) {
    window.open(url, '_blank');
    //window.location.href = url;
    //await Browser.open({url: url});//Questo comando di capacitor non scarica direttamente i pfd o i docs
  }

}
